module.exports = __webpack_public_path__ + "static/media/back_of_right_hand.4f856fed.svg";